import { useState } from 'react';
import { message } from 'antd';

export const useXsjApi = (username: string, displayName?: string) => {
  const [submitLoading, setSubmitLoading] = useState(false);

  // 提交西山居报告任务
  const handleSubmit = async (
    taskName: string,
    excelFile: File,
    imageFiles: File[],
    reportType: string = 'dailyReport'
  ) => {
    if (!username) {
      message.error('用户未登录');
      return false;
    }

    // 任务名验证已在前端处理，这里不再验证

    if (!excelFile) {
      message.error('请上传Excel文件');
      return false;
    }

    if (!imageFiles || imageFiles.length === 0) {
      message.error('请上传图片文件');
      return false;
    }

    setSubmitLoading(true);
    try {
      const formData = new FormData();
      
      // 添加Excel文件
      formData.append('excel', excelFile);
      
      // 添加图片文件数组
      imageFiles.forEach((file) => {
        formData.append('images', file);
      });
      
      // 添加扩展信息
      // 优先使用 displayName（显示的昵称），如果为空则使用 username（用户ID）
      const userName = displayName || username || '';
      const extJson = {
        type: reportType,
        userName: userName
      };
      formData.append('extJson', JSON.stringify(extJson));

      console.log('开始提交西山居报告任务:', {
        taskName,
        excelFile: excelFile.name,
        imageCount: imageFiles.length,
        reportType
      });

      const res = await fetch('/xoyo-daily-report/task/createTask', {
        method: 'POST',
        body: formData,
      });

      if (!res.ok) {
        const errorText = await res.text();
        message.error(`任务提交失败: ${res.status} ${res.statusText}`);
        console.error('提交失败:', errorText);
        return false;
      }

      const data = await res.json();
      console.log('API响应数据:', data);

      if (data.code === 200) {
        message.success(data.message || '任务提交成功！');
        return true;
      } else {
        message.error(data.message || '任务提交失败');
        return false;
      }
    } catch (e) {
      message.error('网络异常，请稍后重试');
      console.error('提交任务异常:', e);
      return false;
    } finally {
      setSubmitLoading(false);
    }
  };

  return {
    submitLoading,
    handleSubmit
  };
};

